import { render, staticRenderFns } from "./BulkDeleteRelations.vue?vue&type=template&id=70c84451"
import script from "./BulkDeleteRelations.vue?vue&type=script&lang=js"
export * from "./BulkDeleteRelations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports